import React from 'react';
import styled from 'styled-components';
import {
  Globe,
  BookOpen,
  PenTool,
  Code,
  Cast,
  Loader,
  Tool,
} from 'react-feather';
const ThemedDiv = styled.div`
  background: ${({ theme }) => theme.bg2};
  color: ${({ theme }) => theme.textColor};
`;

const Skills = () => {
  return (
    <ThemedDiv>
      <div id='skills' className='container'>
        <div className='container max-content'>
          <h2 className='heading-lg pb-3'>let me introduce myself</h2>
          <div
            className='uk-child-width-1-3@m row mb-5 w-100'
            uk-grid
            uk-scrollspy='cls: uk-animation-fade; target: .uk-card; delay: 400; repeat: true'
            uk-height-match='target: > div > .uk-card'
          >
            <div>
              <div className='skills-card mx-4 uk-card uk-card-default uk-card-hover uk-card-body card'>
                <p className='skills-intro'>I am a ...</p>
                <h3 className='uk-card-title card-heading'>LEARNER</h3>
                <p>
                  I love learning and challenging myself in different roles.
                </p>
                <h4>Things I enjoy learning </h4>
                <p>New frameworks & libraries, Science, Education, Cultures </p>
                <h4>Things I've accomplished</h4>
                <ul>
                  <li>
                    <p>
                      <PenTool className='social-icons' />
                    </p>
                    I've published two peer-reviewed articles:{' '}
                    <a
                      href='https://pubmed.ncbi.nlm.nih.gov/28715472/'
                      target='_blank'
                      rel='noreferrer'
                    >
                      here
                    </a>{' '}
                    &{' '}
                    <a
                      href='https://pubmed.ncbi.nlm.nih.gov/25114248/'
                      target='_blank'
                      rel='noreferrer'
                    >
                      here
                    </a>
                  </li>
                  <li>
                    <p>
                      <Globe className='social-icons' />
                    </p>
                    I've lived abroad
                  </li>
                  <li>
                    <p>
                      <BookOpen className='social-icons' />
                    </p>
                    I earned a Masters in Teaching
                  </li>
                </ul>
                {/* <Link to='#' className='link'>
                  See more...
                </Link> */}
              </div>
            </div>
            <div>
              <div className='skills-card mx-4 uk-card uk-card-default uk-card-hover uk-card-body card'>
                <p className='skills-intro'>I am a...</p>
                <h3 className='uk-card-title card-heading'>DEVELOPER</h3>
                <p>I love bringing websites to life with clean code.</p>
                <h4>Languages I speak</h4>
                <p>React, HTML5, CSS3, ES6 JavaScript, C#, NodeJS</p>
                <h4>Tools I use</h4>
                <ul id='skills-tech-list'>
                  <p>
                    <Tool className='social-icons' />
                  </p>
                  <li>Git, Kanban </li>
                  <li>SASS, BEM</li>
                  <li>Figma, Bootstrap, Material-UI</li>
                  <li>Mongoose, Express</li>
                  <li>MongoDb, DynamoDB</li>
                  <li>MSSQL, RDS</li>
                  <li>AWS: Amplify, Cognito</li>
                </ul>
                <br />
                <div className='text-center'>
                  <a
                    href='https://drive.google.com/file/d/1-q-K799PQvgvA5f7p-XRILtd7LAnXbY8/view?usp=sharing'
                    target='_blank'
                    rel='noreferrer'
                    className='link link-to'
                  >
                    <span
                      style={{
                        color: '#69A1AC',
                        textShadow: '1px 1px #2F3676',
                        letterSpacing: '2px',
                      }}
                    >
                      See resume -->>
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div className='skills-card mx-4 uk-card uk-card-default uk-card-hover uk-card-body card'>
                <p className='skills-intro'>I am a...</p>
                <h3 className='uk-card-title card-heading'>EDUCATOR</h3>
                <p>I love to mentor and share what I've learned.</p>
                <h4>What I love about teaching</h4>
                <p>Helping others to achieve their 'AHA!' moment</p>
                <h4>Experiences I've had</h4>
                <ul>
                  <li>
                    {' '}
                    <p>
                      <Cast className='social-icons' />
                    </p>
                    I've taught remotely during global pandemic
                  </li>
                  <li>
                    {' '}
                    <p>
                      <Code className='social-icons' />
                    </p>
                    I taught 10 year olds to code
                  </li>
                  <li>
                    {' '}
                    <p>
                      <Loader className='social-icons' />
                    </p>
                    I've piloted STEM initiatives for the school board
                  </li>
                </ul>
                {/* <Link to='#' className='link'>
                  See more...
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ThemedDiv>
  );
};

export default Skills;
